import _ from 'lodash';
import Device from '../Device';
import vp from '../../../services/api/vp';
import { hwh } from './Common';

const questions = hwh.concat([{
  model: 'ruud',
  type: 'oauth',
  name: 'ruud',
  label: 'step3OauthDeviceRuud',
  role: 'status',
  showNext: false,
  required: true,
  advanceOnEnter: true,
  advanceOnValue: true,
  included: true,
  update: values => ({
    additionalFields: {
      type: 'ruud',
      mixingValve: _.get(values, 'mixingValve'),
      tags: JSON.stringify(_.get(values, 'tags') || {}),
    },
  }),
}]);

const addDevice = async (values, context, signup) => {
  const promise = new Promise((resolve, reject) => {
    signup.$root.$on('oauth.redirect', () => {
      resolve();
    });
  });
  signup.$root.$emit('oauth.submit', values, context);
  return promise;
};

const Ruud = new Device('ruud', { mfg: 'rheem', questions, addDevice });

export default Ruud;
